/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable prefer-template */
import React, { Component } from 'react';
import { Tooltip, withModalContext } from '@jutro/components';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { AccountService } from 'gw-capability-gateway-policy';
import { UserService } from 'gw-capability-gateway';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { AccountClaims } from 'gw-capability-gateway-claim-react';
import { AccountCommission } from 'gw-capability-gateway-commission-react';
import { AccountTimeline } from 'gw-capability-journey-react';
import { withViewModelService, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { isCapabilityEnabled } from '@xengage/gw-portals-config-js';
import { CommonRoutes } from 'gw-capability-gateway-react';
import { MLTagManagerService, withMLModalService, AskServiceOpsService } from 'ml-portals-services-react'
import { FormModalPopover } from 'ml-components-platform-react';
import { MLNewQuoteDialogModal, MLNewQuoteDialogModalMessages } from 'gw-capability-gateway-quoteandbind-common-react';
import cx from 'classnames';
import { MLNameUtil } from 'ml-portals-util-js';
import { MLBundleManager } from 'ml-capability-policychange-common-react';
import metadata from './MLAccountDetails.metadata.json5';
import styles from './MLAccountDetails.module.scss';
import pageRouting from './Accounts-config.json5';
import messages from './MLAccountDetails.messages.js'
import MLTileComponent from '../../components/MLTileComponent/MLTileComponent';
import moment from 'moment';

import { Button } from '@jutro/legacy/components';

import { Link } from '@jutro/router';

import { Identify  } from "../../components/TrackEvent/TrackEvent";
import { PolicyLevelCoverages } from 'gw-capability-claim-react';

import { TranslatorContext, withIntl } from '@jutro/legacy/locale';

const { capabilitiesConfig } = appConfig;
const askSoService = AskServiceOpsService();

class MLAccountDetailsWithoutModalContext extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        match: PropTypes.shape({
            path: PropTypes.string,
            params: PropTypes.shape({
                accountNumber: PropTypes.oneOfType([
                    PropTypes.number,
                    PropTypes.string
                ]),
                type: PropTypes.string
            }),
            url: PropTypes.string
        }).isRequired,
        viewModelService: PropTypes.shape({
            create: PropTypes.func.isRequired,
            clone: PropTypes.func.isRequired,
        }).isRequired,
        location: PropTypes.shape({
            state: PropTypes.string,
            pathname: PropTypes.string
        }).isRequired,
        authenticated: PropTypes.bool.isRequired,
        authHeader: PropTypes.shape({}).isRequired,
        intl: PropTypes.func.isRequired,
        history: PropTypes.shape({
            location: PropTypes.shape({
                state: PropTypes.shape({})
            })
        }).isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            currentView: undefined,
            journeyTurnedOn: false,
            commissionTurnedOn: false,
            accountData: {},
            accountInfo: {},
            accountBillingData: {},
            canCreateAccount: false,
            isLoading: true,
            showProgressDialog: false
        };
    }

    componentDidMount() {
        this.getAccountDetails();
    }

    componentDidUpdate(preProp, preState) {
        const {
            location: { pathname },
            match: {
                params: { accountNumber }
            },
            history
        } = this.props;

        const stateParams = _.get(history, 'location.state');
        if (stateParams && stateParams.bridgedQuoteNumber) {
            this.newQuote(stateParams.bridgedQuoteNumber);
        }

        if (preProp.location.pathname.indexOf(accountNumber) === -1) {
            this.getAccountDetails();
        }
        const currentPage = _.last(pathname.split('/'));
        if (preState.currentView !== currentPage) {
            this.updateCurrentView(currentPage);
        }
        if (!_.isEmpty(preState.accountInfo) && _.isNil(preState.accountInfo.legacyPolicies)) {
            this.getLegacyPolicies()
        }
        if(!this.state.showProgressDialog && this.state.isLoading){
            this.showProgressDialog();
        }
        if(preState.isLoading && !this.state.isLoading){
            this.hideProgressDialog();
        }
    }

    showProgressDialog = () => {
        this.setState({showProgressDialog: true})
        this.props.modalService.showProgressDialog("Loading...");
    }

    hideProgressDialog = () => {
        this.setState({showProgressDialog: false})
        this.props.modalService.hideProgressDialog();
    }

    newQuote = async (preselectedQuoteNumber = null) => {
        const {
            match: {
                params: { accountNumber }
            }
        } = this.props;
        const { accountData } = this.state;

        if (_.isUndefined(accountNumber)) {
            return;
        }

        if (accountData.openQuotes_ML && preselectedQuoteNumber) {
            MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_Add New Quote`);
            const matchQuote = accountData.openQuotes_ML.find((quote) => quote.jobNumber === preselectedQuoteNumber);
            if (matchQuote) {
                matchQuote.preselected = true;
            }
            this.showNewQuoteDialog(accountData);
        }
    };

    mapAccountDetails(accountDetails) {
        const { viewModelService } = this.props;
        const accountInfo = {};
        accountInfo.publicID = accountDetails.publicID;
        accountInfo.policySummaries = _.filter(accountDetails.policySummaries,
            (policy) => policy.isIssued === true);
        accountInfo.accountNumber = accountDetails.accountNumber;
        accountInfo.canCreateSub = accountDetails.canUserCreateSubmission;
        accountInfo.accountBillingSummary = accountDetails.accountBillingSummary;
        accountInfo.accountCreatedDate = accountDetails.accountCreatedDate;
        accountInfo.statusDisplayName = accountDetails.statusDisplayName;
        accountInfo.serviceTier = accountDetails.serviceTier;
        accountInfo.accountBillingSummary = accountDetails.accountBillingSummary;
        accountInfo.producerCodes = accountDetails.producerCodes;
        accountInfo.totalPremium = accountDetails.totalPremium;
        accountInfo.openQuotes_ML = accountDetails.openQuotes_ML;
        accountInfo.customerSince_ML = accountDetails.customerSince_ML;
        accountInfo.pendingPolicyChanges = accountDetails.pendingPolicyChanges_ML;

        // setup account contact details
        const accountHolder = accountDetails.accountHolder;
        accountInfo.subtype = accountHolder.subtype;
        if (accountHolder.subtype === 'Person') {
            accountInfo.firstName = accountHolder.firstName;
            accountInfo.lastName = accountHolder.lastName;
            const nameSuffixList = viewModelService.productMetadata.get('pc').types.getTypelist('NameSuffix');
            const suffix = !_.isNil(accountHolder.suffix) ? nameSuffixList.getCode(accountHolder.suffix).name : '';
            accountInfo.contactName = MLNameUtil.getDisplayNameSuffix(accountHolder, suffix, ' ');
            accountInfo.gender = accountHolder.gender || 'M';
            accountInfo.isPerson = true;
        } else {
            accountInfo.contactName = accountHolder.displayFullName_Ext;
            accountInfo.isCommercial = true;
        }

        accountInfo.primaryAddress = accountHolder.primaryAddress;
        accountInfo.primaryAddress.stateName = viewModelService.productMetadata.get('pc').types.getTypelist('State').getCode(accountHolder.primaryAddress.state).name;
        accountInfo.primaryPhoneType = accountHolder.primaryPhoneType;
        accountInfo.homeNumber = accountHolder.homeNumber;
        accountInfo.workNumber = accountHolder.workNumber;
        accountInfo.cellNumber = accountHolder.cellNumber;
        accountInfo.emailAddress1 = accountHolder.emailAddress1;

        this.setState({
            accountInfo
        });

        this.callIdentifyAPI(this.state.currentView, accountInfo)
    }

    getLegacyPolicies = () => {
        const { accountInfo } = this.state;
        if (_.isEmpty(accountInfo)) {
            return;
        }
        const zipcode = accountInfo.primaryAddress.postalCode;
        const zipcodeShort = zipcode.substring(0, 5);
        const searchCriteria = {
            firstName: accountInfo.firstName,
            lastName: accountInfo.lastName,
            governingRegionShortName: accountInfo.primaryAddress.state,
            zipDeliveryOfficeCode: zipcodeShort,
        };
        const { authHeader, authenticated } = this.props;
        if (authenticated) {
            AccountService.searchByARSPoliciesML(searchCriteria, authHeader).then((searchResults) => {
                if (searchResults.length > 0) {
                    this.setState({
                        accountInfo: {
                            ...accountInfo,
                            legacyPolicies: searchResults
                        }
                    })
                } else {
                    this.setState({
                        accountInfo: {
                            ...accountInfo,
                            legacyPolicies: []
                        }
                    })
                }
            });
        }
    };

    getAccountDetails = () => {
        this.setState({
            isLoading: true
        });
        const {
            authenticated,
            authHeader,
            match: {
                params: { accountNumber }
            },
            location: { state: redirectPath }
        } = this.props;
        if (authenticated) {
            this.getJourneyTurnedOn(accountNumber, authHeader);
            this.getCommissionTurnedOn(authHeader);
            const getPathname = _.get(this.props, 'location.pathname') || '';
            const getActiveTile = getPathname.replace(/\/accounts\/\d+\//g, '');

            const accountDetailsPromise = AccountService.getAccountDetails(accountNumber, authHeader)
                .then((accountDetailsResponse) => {
                    this.mapAccountDetails(accountDetailsResponse);
                    this.setState({
                        accountData: accountDetailsResponse,
                        currentView: redirectPath || getActiveTile || 'summary'
                    });
                    if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' })) {
                        AccountService.getAccountBillingData(accountNumber, authHeader).then(
                            (accountBillingData) => {
                                this.setState({
                                    accountBillingData: accountBillingData,
                                    isLoading: false
                                });
                            }
                        ).finally(() => {
                            this.setState({
                                isLoading: false
                            });
                        });
                    } else {
                        this.setState({
                            isLoading: false
                        });
                    }
                });
            AccountService.addRecentlyViewedAccounts(accountNumber, authHeader);
            return accountDetailsPromise;
        }
    };

    getJourneyTurnedOn = async (accountNumber, authHeader) => {
        const hasUserAccess = await UserService
            .hasUserAccessToAccountPolicies(accountNumber, authHeader);
        this.setState({ journeyTurnedOn: hasUserAccess });
    }

    getCommissionTurnedOn = async (authHeader) => {
        const permissionDTO = {
            permission: 'viewcommissions'
        };
        const commissionTurnedOn = await UserService.hasUserSystemPermission(
            permissionDTO,
            authHeader
        );
        this.setState({ commissionTurnedOn });
    };

    getBillingPaymentIcon = () => {
        const { accountBillingData } = this.state;
        let isDelinquent = false;
        if (!_.isEmpty(accountBillingData) && !_.isEmpty(accountBillingData.ownedPolicies)) {
            isDelinquent = accountBillingData.ownedPolicies.length > 0
                && _.filter(accountBillingData.ownedPolicies, {
                    isDelinquent: true
                }).length > 0;
        }
        if (!_.isEmpty(accountBillingData.unownedPolicies)) {
            isDelinquent = accountBillingData.unownedPolicies.length > 0
                && _.filter(accountBillingData.unownedPolicies, {
                    isDelinquent: true
                }).length > 0;
        }
        return isDelinquent ? 'mi-warning' : 'mi-check';
    };

    getRoutesWithFeature() {
        const routes = [...pageRouting];
        this.commissionsTurnedOn(routes);
        this.journeyFeatureTurnedOn(routes);
        this.billingFeatureTurnedOn(routes);
        return routes;
    }

    journeyFeatureTurnedOn = (routes) => {
        const { journeyTurnedOn } = this.state;
        if (journeyTurnedOn && isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'journey' })) {
            const timelineRoute = {
                path: '/timeline',
                component: AccountTimeline
            };
            routes.push(timelineRoute);
        }
    };

    commissionsTurnedOn = (routes) => {
        const { commissionTurnedOn } = this.state;
        if (
            commissionTurnedOn
            && isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'commission' })
        ) {
            const route = {
                path: '/commission',
                component: AccountCommission
            };
            routes.push(route);
        }
    };

    billingFeatureTurnedOn = (routes) => {
        if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' })) {
            const billingRoute = {
                path: '/billingAndPayment',
                componentPath: 'Accounts/BillingAndPayment/BillingAndPayment'
            };
            routes.push(billingRoute);
        }
    };

    updateCountInfo = (type) => {
        const { accountData } = this.state;
        const currentCount = _.get(accountData, `numberOf${type}`);
        _.set(accountData, `numberOf${type}`, currentCount + 1);
        this.setState({ accountData });
    };

    handleTilesOnClick = (id) => {
        this.setState({ currentView: id });
    };

    getMetadataImplementation = () => {
        const { accountData } = this.state;
        const { currentView } = this.state;
        const baseClassName = 'ml-leftrail-nav__menu-item ';
        const activeClassName = 'active';
        const inactiveClassName = 'right-chevron';
        const overrides = {
            [currentView]: {
                active: true
            },
            accountHeaderNameH2: {
                content: accountData.accountHolder.displayFullName_Ext
            },
            accountHeaderNumberH2: {
                content: `#${accountData.accountNumber}`
            },
            contacts: {
                isContact: true,
                contactDetails: accountData.accountHolder,
                className: baseClassName + 'contacts-info ' + ((currentView === 'contacts') ? activeClassName : inactiveClassName),
            },
            summary : {
                className: baseClassName + ((currentView === 'summary') ? activeClassName : inactiveClassName)
            },
            activities : {
                className: baseClassName + ((currentView === 'activities') ? activeClassName : inactiveClassName)
            },
            payment : {
                className: baseClassName + ((currentView === 'payments') ? activeClassName : inactiveClassName),
                visible: accountData.policySummaries.length > 0
            },
            documents : {
                className: baseClassName + ((currentView === 'documents') ? activeClassName : inactiveClassName)
            }
        };
        const resolvers = {
            resolveCallbackMap: {
                getCell: this.getCell,
                getAccount: this.getAccount,
                getPolicyLink: this.getPolicyLink,
                handleTilesOnClick: this.handleTilesOnClick,
                handleValueChange: this.handleValueChange,
                handleLandingTilesOnClick: this.handleLandingTilesOnClick
            },
            resolveComponentMap: {
                mltilecomponent: MLTileComponent
            }
        };

        return (
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={accountData}
                overrideProps={overrides}
                classNameMap={styles}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
            />
        );
    };

    callIdentifyAPI(currentPage, accountDetails) {
        const {            
            authHeader,            
            authenticated
        } = this.props;

        if (authenticated && accountDetails.policySummaries) {
            try {
                const policyNumbers = [];
                const policyStates = [];
                const policyLobs = [];

                accountDetails.policySummaries.forEach((pol) => {
                    policyNumbers.push(pol.policyNumber);

                    if (!policyStates.includes(pol.baseState)) {
                        policyStates.push(pol.baseState);
                    }

                    if (!policyLobs.includes(pol.product.productName)) {
                        policyLobs.push(pol.product.productName);
                    }
                })

                // Need to set unused properties to 'undefined' so they are not carried over from previous calls
                const props = {               
                    pol_state: undefined,
                    lob: undefined,
                    isCompRater: undefined,
                    quoteID: undefined,
                    bundleIndicator: undefined,
                    step: currentPage,                
                    PolicyNumber: undefined,
                    policyLobs,
                    policyNumbers,
                    policyStates
                }

                Identify('Account Screen Reached', props, null, authHeader)
            } catch (e) {
                console.error(`Error calling identify API in MLAccountDetails: ${e.message}`);
            }
        }
    };
    
    updateCurrentView(currentPage) {
        const excludePage = ['contactDetails'];
        if (excludePage.indexOf(currentPage) !== -1) {
            return;
        }

        if (currentPage !== this.state.currentView) {            
            this.callIdentifyAPI(currentPage, this.state.accountInfo);
        }

        this.setState({
            currentView: currentPage
        });
    }

    showNewQuoteDialog = (account) => {
        const { history, viewModelService, authHeader } = this.props
        const translator = this.context;
        const accountVM = viewModelService.create(account, 'pc', 'edge.capabilities.gateway.account.dto.AccountDTO');
        const overrides = {
            model: accountVM,
            history
        };

        const componentProps = {
            title: translator(MLNewQuoteDialogModalMessages.startAQuote),
            overrideProps: overrides,
            CustomComponent: MLNewQuoteDialogModal,
            buttonType: 'outlined',
            showFooterOnCustomComponent: false,
            additionalPEStyle: 'customFooterModal',
            viewModelService,
            authHeader
        };
        this.props.modalContext.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    
    handleNewQuoteClick = () => {
        const { authHeader } = this.props;
        const {
            accountData: { accountNumber }
        } = this.state;

        if (_.isUndefined(accountNumber)) {
            return;
        }

        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_Add New Quote`);

        const accountDetailsPromise = AccountService.getAccountDetails(accountNumber, authHeader);
        accountDetailsPromise.then((account) => {
            this.showNewQuoteDialog(account);
        });
    };

    showNewQuoteButton = async () => {
        const { authHeader } = this.props;
        const accountPermCheckDTO = {
            permEntityType: 'Account',
            permEntityID: null,
            permission: 'create',
            isCheckPermEntity: false
        };

        const canCreateAccount = await UserService.hasUserPermission(
            accountPermCheckDTO,
            authHeader
        );
        this.setState({ canCreateAccount });
    };

    handleCreateManageBundleClick = () => {
        const { accountInfo } = this.state;
        this.props.modalContext.showModal(
            <MLBundleManager policies={accountInfo.policySummaries} />
        );
    }

    getMakeChangesTabContent = () => {
        return (
            <ul className={cx(styles.makeChangesList)}>
                <li>
                    <Link className={cx(styles.makeChangesLink)} onClick={this.handleCreateManageBundleClick}>
                        {messages.manageBundle.defaultMessage}
                    </Link>
                </li>
            </ul>
        );
    }

    getMakeChangesHeading = (accountData) => {
        return (accountData.policySummaries.length > 1) ? (
            <Tooltip
                id="makeChangesTooltip"
                placement="bottom"
                trigger="click"
                content={this.getMakeChangesTabContent()}
            >
                <Button className={cx(styles.pullRight, styles.buttonMargin, 'ml-btn')}>
                    {_.toString(messages.makeChanges.defaultMessage + '  ')}
                    <i className="icon-ml-carrot-down-outline" />
                </Button>
            </Tooltip>

        ) : <></>
    };

    updateAccountInfo = (accountInfo) => {
        this.setState({accountInfo});
    };

    convertLocalDateToDate = (localDate) => {
        if (_.isNil(localDate)) {
            return '';
        }        
        const parsedDate = new Date(localDate.year, localDate.month, localDate.day);
        return moment(parsedDate).format('MM/YYYY');        
    };

    render() {
        const { accountInfo, accountData, isLoading, accountBillingData, canCreateAccount } = this.state;
        if (isLoading) {
            // return <Loader loaded={!isLoading} />;
            return <></>
        }
        const {
            match: { url }
        } = this.props;        
        const accountActivitiesData = {
            accountData: accountData,
            getUpdateCountInfo: this.updateCountInfo
        };

        askSoService.storeCurrentPageData(this.state.accountInfo.primaryAddress.state, '', '', this.state.accountInfo.accountNumber);

        return (
            <div className="display-flex clearfix">
                {this.getMetadataImplementation()}
                <div className={cx('ml-leftrail-nav__wrapper-right')}>
                    <div className={cx('ml-main-header short for-details')}>
                        <div className={cx('clearfix')}>
                            <div className={cx(styles.customerSince, 'display-inline-block')}>
                              <strong>{_.toString(messages.customerSince.defaultMessage)}</strong>                            
                              {this.convertLocalDateToDate(accountInfo.customerSince_ML)}
                            </div>
                            <div className={cx(styles.pullRight, 'display-inline-block')}>
                                <Button type="outlined" className={styles.pullRight} onClick={this.handleNewQuoteClick} visible={this.showNewQuoteButton && canCreateAccount}>
                                    {_.toString(messages.addNewQuote.defaultMessage)}
                                </Button>
                                {this.getMakeChangesHeading(accountData)}
                            </div>
                        </div>
                    </div>
                    <div className="pc-page-content">
                        <CommonRoutes
                            steps={this.getRoutesWithFeature()}
                            basePath={url}
                            accountInfo={accountInfo}
                            updateAccountInfo={this.updateAccountInfo}
                            accountDetailsData={accountData}
                            accountActivitiesData={accountActivitiesData}
                            billingData={accountBillingData}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
const MLAccountDetails = withModalContext(MLAccountDetailsWithoutModalContext);
export const AccountsSummary = MLAccountDetails;
export default withMLModalService(withRouter(withIntl(withAuthenticationContext(withViewModelService(MLAccountDetails)))));
